var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeltaup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292787 5.70703C0.105316 5.5195 0 5.26519 0 5.00003C0 4.73487 0.105316 4.48056 0.292787 4.29303L4.29279 0.293031C4.48031 0.105559 4.73462 0.000244141 4.99979 0.000244141C5.26495 0.000244141 5.51926 0.105559 5.70679 0.293031L9.70679 4.29303C9.88894 4.48163 9.98974 4.73423 9.98746 4.99643C9.98518 5.25863 9.88001 5.50944 9.6946 5.69485C9.5092 5.88026 9.25838 5.98543 8.99619 5.9877C8.73399 5.98998 8.48139 5.88919 8.29279 5.70703L5.99979 3.41403V15C5.99979 15.2652 5.89443 15.5196 5.70689 15.7071C5.51936 15.8947 5.265 16 4.99979 16C4.73457 16 4.48022 15.8947 4.29268 15.7071C4.10514 15.5196 3.99979 15.2652 3.99979 15V3.41403L1.70679 5.70703C1.51926 5.8945 1.26495 5.99982 0.999786 5.99982C0.734622 5.99982 0.480314 5.8945 0.292787 5.70703Z",
    fill: "#47D16C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaup);
export default __webpack_public_path__ + "static/media/deltaup.3b93c2618e58d0e2262056190cff874a.svg";
export { ForwardRef as ReactComponent };